// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingPage_container__10-TY","startFading":"loadingPage_startFading__iqwuY"};